import { FilterSharp } from '@mui/icons-material';
import Api from '../../../../Api';
import { IExport } from '../../../../shared-interfaces/IExport';
import { ICategory } from '../../../../shared-interfaces/Notation/ICategory';
import { ICoreUser } from '../../../../shared-interfaces/User/ICoreUser';
import { Inclusion } from '../../../../shared-types/Inclusion';
import { INotationIdentifier } from '../Interfaces/INotationIdentifier';

export interface IExportRequest {
  categories: ICategory[];
  notationTypes: string[];
  createdFor: ICoreUser | undefined;
  createdBy: ICoreUser | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
  restrictedTo: Inclusion;
  ids?: INotationIdentifier[];
  assignedTo?: ICoreUser;
  onlyUnassigned?: boolean;
}

export interface INotationExportCriteria {
  restrictedTo: Inclusion;
  notationTypes: string[];
  ids: number[];
  categoryIds: number[];
  createdBy?: string;
  createdFor?: string;
  assignedTo?: string;
  onlyUnassigned?: boolean;
  startDate?: Date;
  endDate?: Date;
  createdForUser?: ICoreUser;
  createdByUser?: ICoreUser;
  categories: ICategory[];
}

export interface INotationExport extends IExport {
  criteria: INotationExportCriteria;
}

const map = (record: INotationExport): INotationExport => {
  return {
    ...record,
    createdOn: new Date(record.createdOn),
    expiresOn: new Date(record.expiresOn),
    completedOn: record.completedOn ? new Date(record.completedOn) : undefined,
    download: record.download
      ? {
          url: record.download.url,
          expiresOn: new Date(record.download.expiresOn),
        }
      : undefined,
    criteria: {
      ...record.criteria,
      startDate: record.criteria.startDate
        ? new Date(record.criteria.startDate)
        : undefined,
      endDate: record.criteria.endDate
        ? new Date(record.criteria.endDate)
        : undefined,
    },
  };
};

const ExportService = {
  getExportStatuses: async (): Promise<INotationExport[]> => {
    const response = await Api.get(`management/notation/exports`);
    return response.data
      .map((x: INotationExport) => map(x))
      .sort(
        (a: INotationExport, b: INotationExport) =>
          b.createdOn.getTime() - a.createdOn.getTime(),
      );
  },
  getExportStatus: async (id: string): Promise<INotationExport> => {
    const response = await Api.get(`management/notation/exports/${id}`);
    return map(response.data);
  },
  startExport: async (filter: IExportRequest): Promise<INotationExport> => {
    const response = await Api.post(`management/notation/exports`, {
      ...filter,
      createdBy: filter.createdBy?.id,
      createdFor: filter.createdFor?.id,
      assignedTo: filter.assignedTo?.id,
      categoryIds: filter.categories ? filter.categories.map(x => x.id) : [],
    });
    return map(response.data);
  },
};

export default ExportService;
